<template>
  <section v-if="banners.length" class="banner-section" dir="rtl" aria-label="إعلانات">
    <div class="banner-wrap">
      <!-- Single banner: no carousel -->
      <BannerCard v-if="banners.length === 1" :banner="banners[0]" @cta="onCta" />

      <!-- Multiple banners: reuse the existing Swiper slider -->
      <Swiper
        v-else
        class="banner-swiper"
        dir="rtl"
        :modules="swiperModules"
        :slides-per-view="1"
        :space-between="14"
        :loop="banners.length > 1"
        :autoplay="{ delay: 6000, disableOnInteraction: false, pauseOnMouseEnter: true }"
        :pagination="{ clickable: true }"
        :grab-cursor="true"
        :a11y="{ enabled: true }"
      >
        <SwiperSlide v-for="b in banners" :key="b.id">
          <BannerCard :banner="b" @cta="onCta" />
        </SwiperSlide>
      </Swiper>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { A11y, Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import BannerCard from './BannerCard.vue';
import { bannersService } from '@/services/bannersService';

const swiperModules = [A11y, Autoplay, Pagination];
const banners = ref([]);
const router = useRouter();

function onCta(url) {
  if (!url) return;
  // Internal path → vue-router; absolute URL → new tab.
  if (/^https?:\/\//i.test(url)) {
    window.open(url, '_blank', 'noopener');
  } else {
    router.push(url);
  }
}

onMounted(async () => {
  try {
    banners.value = await bannersService.getActive();
  } catch {
    banners.value = [];
  }
});
</script>

<style scoped>
.banner-section { direction: rtl; padding: 1.25rem 0 0; }
.banner-wrap { max-width: 1200px; margin: 0 auto; padding: 0 1rem; }
.banner-swiper { overflow: hidden; padding-bottom: 2rem; --swiper-theme-color: #5B5FEF; --swiper-pagination-bullet-size: 8px; }
:deep(.swiper-pagination) { bottom: 0 !important; }

@media (max-width: 768px) {
  .banner-section { padding-top: .75rem; }
  .banner-wrap { padding: 0 .75rem; }
}
</style>
